import Vue from 'vue/dist/vue.js'
import Buefy from 'buefy'
import router from '@/router'
import { BackendPlugin } from '@/backend'

Vue.use(Buefy, {
  defaultIconPack: 'fas',
})

Vue.use(BackendPlugin, { router })

import AddNoteModal from '@/components/common/AddNoteModal.vue'
import EditNoteModal from '@/components/common/EditNoteModal.vue'
import FormPaper from '@/components/papers/FormPaper.vue'
import FormGroup from '@/components/groups/FormGroup.vue'
import FormIntent from '@/components/intents/FormIntent.vue'
import FormReviewQuestionTemplate from '@/components/review_question_templates/FormReviewQuestionTemplate.vue'
import LinkFollower from '@/components/common/LinkFollower.vue'
import ListReports from '@/components/reports/ListReports.vue'
import PrintButton from '@/components/common/PrintButton.vue'
import RankTable from '@/components/reviews/RankTable.vue'
import ReviewForm from '@/components/reviews/form/ReviewForm.vue'
import ReviewShowOverviewTab from '@/components/reviews/OverviewTab.vue'
import ReviewScoreRankTab from '@/components/reviews/ScoreRankTab.vue'
import ShowGroup from '@/components/groups/ShowGroup.vue'
import PromptCloseModal from '@/components/reviews/PromptCloseModal.vue'
import QuestionForm from '@/components/user_reviews/QuestionForm.vue'
import RequestChangesModal from '@/components/common/RequestChangesModal.vue'
import MailerPreviewModal from '@/components/admin/MailerPreviewModal.vue'

// Event delegation for delete buttons (vanilla JavaScript replacement for Rails UJS)
document.addEventListener('click', function (event) {
  if (event.target.closest('.delete-button')) {
    event.preventDefault()
    const button = event.target.closest('.delete-button')
    const url = button.dataset.deleteUrl
    const message = button.dataset.deleteConfirm

    if (confirm(message)) {
      const form = document.createElement('form')
      form.method = 'POST'
      form.action = url

      const methodInput = document.createElement('input')
      methodInput.type = 'hidden'
      methodInput.name = '_method'
      methodInput.value = 'DELETE'

      const tokenInput = document.createElement('input')
      tokenInput.type = 'hidden'
      tokenInput.name = 'authenticity_token'
      tokenInput.value = document.querySelector(
        'meta[name="csrf-token"]'
      ).content

      form.appendChild(methodInput)
      form.appendChild(tokenInput)
      document.body.appendChild(form)
      form.submit()
    }
  }
})

// Event delegation for PUT/PATCH method buttons and links (vanilla JavaScript replacement for Rails UJS)
document.addEventListener('click', function (event) {
  const httpMethodElement =
    event.target.closest('.http-method-button') ||
    event.target.closest('a[data-method-url]')
  if (httpMethodElement) {
    // Check if the element is disabled
    if (
      httpMethodElement.hasAttribute('disabled') ||
      httpMethodElement.classList.contains('disabled')
    ) {
      event.preventDefault()
      return
    }

    event.preventDefault()
    const url = httpMethodElement.dataset.methodUrl
    const method = httpMethodElement.dataset.httpMethod
    const message = httpMethodElement.dataset.confirm

    let shouldSubmit = true
    if (message) {
      shouldSubmit = confirm(message)
    }

    if (shouldSubmit) {
      const form = document.createElement('form')
      form.method = 'POST'
      form.action = url

      const methodInput = document.createElement('input')
      methodInput.type = 'hidden'
      methodInput.name = '_method'
      methodInput.value = method

      const tokenInput = document.createElement('input')
      tokenInput.type = 'hidden'
      tokenInput.name = 'authenticity_token'
      tokenInput.value = document.querySelector(
        'meta[name="csrf-token"]'
      ).content

      form.appendChild(methodInput)
      form.appendChild(tokenInput)
      document.body.appendChild(form)
      form.submit()
    }
  }
})

import { initPasskeys } from '@/passkeys'

function bindPasswordModal() {
  document.addEventListener('click', function (event) {
    const openButton = event.target.closest('[data-open-password-modal]')
    if (openButton) {
      event.preventDefault()
      document.getElementById('password-modal')?.classList.add('is-active')
      return
    }

    const closeButton = event.target.closest('[data-close-password-modal]')
    if (closeButton) {
      event.preventDefault()
      document.getElementById('password-modal')?.classList.remove('is-active')
    }
  })
}

document.addEventListener('DOMContentLoaded', function () {
  var csrfToken = document
    .querySelector('meta[name="csrf-token"]')
    .getAttribute('content')

  bindPasswordModal()

  var element = document.getElementById('app')
  if (element) {
    var tabsEl = document.getElementById('tabs')
    var activeTab = 0
    if (tabsEl && tabsEl.dataset.activeTab !== undefined) {
      activeTab = parseInt(tabsEl.dataset.activeTab, 10) || 0
    } else if (element.dataset.activeTab !== undefined) {
      activeTab = parseInt(element.dataset.activeTab, 10) || 0
    }

    new Vue({
      el: '#app',
      data: {
        activeTab: activeTab,
      },
      components: {
        AddNoteModal,
        EditNoteModal,
        PromptCloseModal,
        RequestChangesModal,
        MailerPreviewModal,
        'form-group': FormGroup,
        'form-intent': FormIntent,
        'form-paper': FormPaper,
        'form-review-question-template': FormReviewQuestionTemplate,
        'link-follower': LinkFollower,
        'list-reports': ListReports,
        'print-button': PrintButton,
        'rank-table': RankTable,
        'review-form': ReviewForm,
        'review-show-score-rank-tab': ReviewScoreRankTab,
        'review-show-overview-tab': ReviewShowOverviewTab,
        'question-form': QuestionForm,
        'show-group': ShowGroup,
      },
      mounted: function () {
        initPasskeys()
      },
      methods: {
        addNote: function (commentableId, commentableType) {
          this.$buefy.modal.open({
            parent: this,
            component: AddNoteModal,
            hasModalCard: true,
            trapFocus: true,
            props: {
              csrfToken: csrfToken,
              commentableId: commentableId,
              commentableType: commentableType,
            },
          })
        },
        editNote: function (userCommentId, contents) {
          this.$buefy.modal.open({
            parent: this,
            component: EditNoteModal,
            hasModalCard: true,
            trapFocus: true,
            props: {
              csrfToken: csrfToken,
              userCommentId: userCommentId,
              contents: contents,
            },
          })
        },
        promptDeleteNote: function (userCommentId, redirectPath) {
          this.$buefy.dialog.confirm({
            title: 'Delete Note',
            message: 'Are you sure you want to <b>delete</b> this note?',
            confirmText: 'Delete Note',
            type: 'is-danger',
            hasIcon: true,
            onConfirm: () => {
              this.$secured
                .delete(`/user_comments/${userCommentId}`)
                .then(() => {
                  window.location.href = redirectPath
                })
                .catch((error) => {
                  console.error(error)
                })
            },
          })
        },
        promptClose: function (reviewId, deadlineAt) {
          this.$buefy.modal.open({
            parent: this,
            component: PromptCloseModal,
            hasModalCard: true,
            trapFocus: true,
            props: {
              csrfToken: csrfToken,
              reviewId: reviewId,
              deadlineAt: deadlineAt,
            },
          })
        },
        requestChanges: function (reviewableId, reviewableType, action) {
          this.$buefy.modal.open({
            parent: this,
            component: RequestChangesModal,
            hasModalCard: true,
            trapFocus: true,
            props: {
              csrfToken: csrfToken,
              reviewableId: reviewableId,
              reviewableType: reviewableType,
              action: action,
            },
          })
        },
        previewMailer: function (previewUrl, title) {
          this.$buefy.modal.open({
            parent: this,
            component: MailerPreviewModal,
            hasModalCard: true,
            trapFocus: true,
            canCancel: ['escape', 'outside'],
            width: 960,
            props: {
              previewUrl: previewUrl,
              title: title,
            },
          })
        },
      },
    })
  } else {
    initPasskeys()
  }
})
